import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import {
  FormCard, FormCardHeader, Line, LinkContainer, StyledLink, SubmitButton, StyledA
} from "styles/styled";
import {RootState} from 'store';
import styled from "styled-components";
import {$Action, Colors, Spacing} from "styles/constants";
import SuccessIcon from "../../../assets/svg/success-icon";
import {Routes} from "../../../routes";
import AppSpinner from "../../spinner/spinner";
import { AuthActions, AuthEffects } from "../../../store/auth";

const ActionText = styled.h1 `{
  font-size: 36px;
  line-height: 36px;
  font-weight: 600;
  color: ${Colors.SlateDark};
  margin-bottom: ${Spacing.Space4};
  text-align: center;
}`;

const TextContainer = styled.div `{
  text-align: center;
  width: 100%;
  color: ${Colors.SlateDark};
  margin: ${Spacing.Space4} auto;
}`;

const SuccessVerifyEmail = () => {
  const dispatch = useDispatch();
  const urlExtension = useSelector((state: RootState) => state.app.urlExtension);
  const queryParams = useSelector((state: RootState) => state.app.queryParams);
  const {isAuthenticated} = useSelector((state: RootState) => state.auth.session);
  const allowToken = useSelector((state: RootState) => state.auth.allowToken);

  const handleClick = () => {
    window.location.assign('/authenticate/awaiting' + urlExtension);
  };

  const handleDisable = () => {
    allowToken && dispatch(AuthActions.setRejectToken(allowToken));
    allowToken && dispatch(AuthEffects.rejectEmail2fa(allowToken));
  };

  const actionCopy = isAuthenticated ? <p>You may continue to your intended destination.</p> : <p>Please <StyledLink role="link" to={Routes.LOGIN + urlExtension}>login</StyledLink> to continue.</p>;

  return (
    <>
      {queryParams.apply === 'emailAuth' ?
        (!isAuthenticated ?
          <AppSpinner/>
          :
          <>
            <FormCard>
              <FormCardHeader>Email Authentication</FormCardHeader>
              <Line />
              <ActionText>Success</ActionText>
              <SuccessIcon color={$Action} size={'55'} />
              <TextContainer>
                <p>Email successfully authenticated.</p>
                {actionCopy}
              </TextContainer>
              {isAuthenticated &&
              <SubmitButton type="button" role="button" aria-label="close" onClick={handleClick}>Continue</SubmitButton>}
            </FormCard>
            <LinkContainer>
              <p>If this was a mistake, you can <StyledA as='span' onClick={handleDisable}>disable</StyledA> the session here.</p>
            </LinkContainer>
          </>
        )
        :
        <FormCard>
          <FormCardHeader>Email Verification</FormCardHeader>
          <Line />
          <ActionText>Success</ActionText>
          <SuccessIcon color={$Action} size={'55'} />
          <TextContainer>
            <p>Email successfully verified.</p>
            {actionCopy}
          </TextContainer>
          {isAuthenticated &&
          <SubmitButton type="button" role="button" aria-label="close" onClick={handleClick}>Continue</SubmitButton>}
        </FormCard>
      }
    </>
  );
};

export default SuccessVerifyEmail;
